import React from 'react';
import { FadeIn } from './FadeIn';
import { X } from 'lucide-react';
interface WhySolutionsFailProps {
  lang?: 'en' | 'es';
}
const failures = {
  en: [{
    title: 'Big chain salons',
    reason: "Cookie-cutter services. No cultural competency. They don't understand diverse hair textures."
  }, {
    title: 'Budget nail/hair spots',
    reason: 'Rushed, impersonal, low attention to detail — you get what you pay for.'
  }, {
    title: 'Random stylists on social media',
    reason: 'Inconsistent quality, no fixed location, no accountability.'
  }, {
    title: 'DIY at home',
    reason: "Products don't deliver. Techniques go wrong. Stress instead of self-care."
  }, {
    title: 'Other local salons',
    reason: "Long waits, no personalization, you leave feeling just 'okay' — not transformed."
  }],
  es: [{
    title: 'Cadenas de salones',
    reason: 'Servicios genéricos. Sin competencia cultural. No entienden las texturas de cabello diversas.'
  }, {
    title: 'Salones económicos',
    reason: 'Apresurados, impersonales, poca atención al detalle — recibes lo que pagas.'
  }, {
    title: 'Estilistas en redes sociales',
    reason: 'Calidad inconsistente, sin ubicación fija, sin responsabilidad.'
  }, {
    title: 'Hacerlo en casa',
    reason: 'Los productos no funcionan. Las técnicas salen mal. Estrés en vez de autocuidado.'
  }, {
    title: 'Otros salones locales',
    reason: 'Largas esperas, sin personalización, sales sintiéndote "más o menos" — no transformada.'
  }]
};
const titles = {
  en: "Why You've Been Disappointed Before",
  es: 'Por Qué Has Quedado Decepcionada Antes'
};
export function WhySolutionsFail({
  lang = 'en'
}: WhySolutionsFailProps) {
  return <section className="py-24 md:py-32 bg-brand-dark text-brand-cream" data-id="element-327">
      <div className="max-w-5xl mx-auto px-6" data-id="element-328">
        <FadeIn data-id="element-329">
          <div className="text-center mb-16" data-id="element-330">
            <h2 className="font-serif text-3xl md:text-5xl mb-6" data-id="element-331">
              {titles[lang]}
            </h2>
            <div className="w-16 h-[1px] bg-brand-gold mx-auto" data-id="element-332"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-333">
          {failures[lang].map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-334">
              <div className="bg-[#232323] border border-[#333] p-8 h-full flex flex-col hover:border-brand-wine/50 transition-colors duration-300" data-id="element-335">
                <div className="flex items-center gap-3 mb-4" data-id="element-336">
                  <div className="w-8 h-8 rounded-full bg-brand-wine/20 flex items-center justify-center flex-shrink-0" data-id="element-337">
                    <X className="w-4 h-4 text-brand-wine" data-id="element-338" />
                  </div>
                  <h3 className="font-serif text-xl text-brand-gold" data-id="element-339">
                    {item.title}
                  </h3>
                </div>
                <p className="font-sans text-brand-cream/70 leading-relaxed" data-id="element-340">
                  {item.reason}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}